import {saveElement, updateElement, UserElement} from "../../../reducers/User/UserReducer";
import {useAppDispatch, useAppSelector} from "../../../reducers/hooks";
import {Form, FormikProvider, useFormik} from "formik";
import * as Yup from "yup";
import Divider from "@mui/material/Divider";
import React, {useEffect, useState} from "react";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import {
    Checkbox,
    DialogActions,
    DialogContent,
    FormControlLabel,
    FormHelperText,
    IconButton,
    InputAdornment,
    MenuItem,
    OutlinedInput,
    Select
} from "@mui/material";
import {getAllElement} from "../../../reducers/Tenant/TenantReducer";
import FormControl from "@mui/material/FormControl";
import {FormattedMessage, useIntl} from "react-intl";
import {Autocomplete} from "@mui/lab";
import {ColumnFiltersState} from "@tanstack/react-table";
import {Eye, EyeSlash} from "iconsax-react";


interface UserFormProps {
    closeModal: () => void;
    element: UserElement | null;
    onSuccess?: () => void;
    pageableData?: {
        page: number;
        rowsPerPage: number;
        filters: ColumnFiltersState | null;
    };
}

export const UserElementForm: React.FC<UserFormProps> = ({
                                                             closeModal,
                                                             element,
                                                             onSuccess,
                                                             pageableData
                                                         }) => {

    const dispatch = useAppDispatch();
    const tenant = useAppSelector((state) => state.tenantElement.elements);
    const intl = useIntl()
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        dispatch(getAllElement());
    }, []);

    const formik = useFormik({
        initialValues: element ? element : {
            _id: '',
            username: '',
            email: '',
            password: '',
            enabled: false,
            tenantId: null,
            roles: ''
        },


        validationSchema: Yup.object().shape({
            username: Yup.string()
                .min(2, intl.formatMessage({id: "Username length not valid"}))
                .max(255)
                .required(intl.formatMessage({id: "Username is required"}))
                .test(
                    'username-match-email',
                    intl.formatMessage({id: "Username must match the email"}),
                    function (value) {
                        return value === this.parent.email; // Confronta con l'email
                    }
                ),

            email: Yup.string()
                .min(6, intl.formatMessage({id: "The email length is not valid"}))
                .required(intl.formatMessage({id: "Email is required"})),
            tenantId: Yup.object().nullable(),
            enabled: Yup.boolean().required(intl.formatMessage({id: "Enabled status is required"})),
            //roles: Yup.string().required(intl.formatMessage({ id: "roles is required" })),
            /*password: Yup.string()
             .min(8, 'Password must be at least 8 characters')
             .matches(
                 /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
             )
             .required('Password is required'),*/
        }),

        enableReinitialize: true,
        onSubmit: async (values) => {
            try {
                if (element && element._id) {
                    dispatch(updateElement({
                        data: values,
                        callback: () => {
                            closeModal();
                            onSuccess?.();
                        }
                    }))
                } else {

                    dispatch(saveElement({
                        data: values,
                        callback: () => {
                            closeModal();
                            onSuccess?.();
                        }
                    }));
                }
                closeModal();
            } catch (error) {
                console.error('Error:', error);
            }
        }
    });

    if (element && element._id) {
        return (
            <>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                        <DialogTitle>{intl.formatMessage({id: "Newuser"})}</DialogTitle>
                        <Divider/>
                        <DialogContent sx={{p: 2.5}}>
                            <Grid container spacing={3}>

                                {/* Email */}
                                <Grid item xs={12} sm={6}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="element-email">Email</InputLabel>
                                        <TextField
                                            type="email"
                                            fullWidth
                                            id="element-email"
                                            placeholder={intl.formatMessage({id: "Insert the email"})}
                                            {...formik.getFieldProps('email')}
                                            error={Boolean(formik.touched.email && formik.errors.email)}
                                            helperText={formik.touched.email && formik.errors.email}
                                        />
                                    </Stack>
                                </Grid>
                                {/* Username */}
                                <Grid item xs={12} sm={6}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="element-username">
                                            <FormattedMessage id="Username" defaultMessage="Username"/>
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            id="element-username"
                                            placeholder={intl.formatMessage({id: "Insert the username"})}
                                            {...formik.getFieldProps('username')}
                                            error={Boolean(formik.touched.username && formik.errors.username)}
                                            helperText={formik.touched.username && formik.errors.username}
                                        />
                                    </Stack>
                                </Grid>

                                {/* Password */}
                                {/* <Grid item xs={12} sm={6}>
                                   <Stack spacing={1}>
                                       <InputLabel htmlFor="element-password">Password</InputLabel>
                                       <TextField
                                           type="password"
                                           fullWidth
                                           id="element-password"
                                           placeholder="Insert the password"
                                           {...formik.getFieldProps('password')}
                                           error={Boolean(formik.touched.password && formik.errors.password)}
                                           helperText={formik.touched.password && formik.errors.password}
                                       />
                                   </Stack>
                               </Grid>*/}


                                {/* Active Checkbox */}
                                <Grid item xs={12} sm={6}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="element-enabled">Active</InputLabel>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    id="element-enabled"
                                                    checked={formik.values.enabled}
                                                    onChange={(e) => formik.setFieldValue('enabled', e.target.checked)}
                                                    name="enabled"
                                                    color="primary"
                                                />
                                            }
                                            label="Enabled"
                                        />
                                        {formik.touched.enabled && formik.errors.enabled && (
                                            <span style={{color: 'red'}}>{formik.errors.enabled}</span>
                                        )}
                                    </Stack>
                                </Grid>

                                {/* Tenant Dropdown */}
                                <Grid item xs={12} sm={6}>
                                    <Stack spacing={1}>
                                        <FormControl fullWidth
                                                     error={Boolean(formik.touched.tenantId && formik.errors.tenantId)}>
                                            <Autocomplete
                                                id="tenantId"
                                                value={formik.values.tenantId || undefined}
                                                onChange={(e, newValue) => formik.setFieldValue('tenantId', newValue)}

                                                getOptionLabel={(option) => option.businessName || option?._id || ''}
                                                isOptionEqualToValue={(option, value) => option._id === value?._id}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Tenant"
                                                        error={Boolean(formik.touched.tenantId && formik.errors.tenantId)}
                                                        helperText={formik.touched.tenantId ? "Please select a valid tenant." : null}
                                                    />
                                                )}
                                                noOptionsText="No tenants found"
                                                disableClearable
                                                options={tenant}/>
                                            {formik.touched.tenantId && formik.errors.tenantId && (
                                                <FormHelperText error>{formik.errors.tenantId}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Stack>
                                </Grid>


                                {/* roles Dropdown */}
                                <Grid item xs={12} sm={6}>
                                    <Stack spacing={1}>
                                        <FormControl fullWidth
                                                     error={Boolean(formik.touched.roles && formik.errors.roles)}>
                                            <InputLabel htmlFor="element-roles">roles</InputLabel>
                                            <Select
                                                id="element-roles"
                                                {...formik.getFieldProps('roles')}
                                                value={formik.values.roles}
                                                onChange={(e) => formik.setFieldValue('roles', e.target.value)}
                                            >
                                                <MenuItem value="USER">User</MenuItem>
                                                <MenuItem value="ADMIN">Admin</MenuItem>
                                                <MenuItem value="SUPER_ADMIN">Super Admin</MenuItem>
                                            </Select>
                                            {formik.touched.roles && formik.errors.roles && (
                                                <FormHelperText>{formik.errors.roles}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <Divider/>
                        <DialogActions sx={{p: 2.5}}>
                            <Grid container justifyContent="flex-end" alignItems="center">
                                <Grid item>
                                    <Stack direction="row" spacing={2} alignItems="center">
                                        <Button color="error" onClick={closeModal}>
                                            Cancel
                                        </Button>
                                        <Button type="submit" variant="contained">
                                            Save
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </Form>
                </FormikProvider>
            </>
        );

    } else {
        return (
            <>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                        <DialogTitle>{intl.formatMessage({id: "New user"})}</DialogTitle>
                        <Divider/>
                        <DialogContent sx={{p: 2.5}}>
                            <Grid container spacing={3}>

                                {/* Email */}
                                <Grid item xs={12} sm={6}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="element-email">Email</InputLabel>
                                        <TextField
                                            type="email"
                                            fullWidth
                                            id="element-email"
                                            placeholder={intl.formatMessage({id: "Insert the email"})}
                                            {...formik.getFieldProps('email')}
                                            error={Boolean(formik.touched.email && formik.errors.email)}
                                            helperText={formik.touched.email && formik.errors.email}
                                        />
                                    </Stack>
                                </Grid>
                                {/* Username */}
                                <Grid item xs={12} sm={6}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="element-username">
                                            <FormattedMessage id="Username" defaultMessage="Username"/>
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            id="element-username"
                                            placeholder={intl.formatMessage({id: "Insert the username"})}
                                            {...formik.getFieldProps('username')}
                                            error={Boolean(formik.touched.username && formik.errors.username)}
                                            helperText={formik.touched.username && formik.errors.username}
                                        />
                                    </Stack>
                                </Grid>


                                {/* Password */}
                                <Grid item xs={12} sm={6}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="element-password">Password</InputLabel>
                                        <FormControl fullWidth variant="outlined">
                                            <OutlinedInput
                                                type={showPassword ? 'text' : 'password'}
                                                {...formik.getFieldProps('password')}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            edge="end"
                                                        >
                                                            {showPassword ? <Eye/> : <EyeSlash/>}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                        </FormControl>
                                    </Stack>
                                </Grid>


                                {/* Tenant Dropdown */}
                                <Grid item xs={12} sm={6}>
                                    <Stack spacing={1}>
                                        <InputLabel htmlFor="element-tenant">Tenant</InputLabel>

                                        <FormControl fullWidth
                                                     error={Boolean(formik.touched.tenantId && formik.errors.tenantId)}>
                                            <Autocomplete
                                                id="tenantId"
                                                value={formik.values.tenantId || undefined}
                                                onChange={(e, newValue) => formik.setFieldValue('tenantId', newValue)}

                                                getOptionLabel={(option) => option.businessName || ''}
                                                isOptionEqualToValue={(option, value) => option.businessName === value?.businessName}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Tenant"
                                                        error={Boolean(formik.touched.tenantId && formik.errors.tenantId)}
                                                        helperText={formik.touched.tenantId ? "Please select a valid tenant." : null}
                                                    />
                                                )}
                                                noOptionsText="No tenants found"
                                                disableClearable
                                                options={tenant}/>
                                            {formik.touched.tenantId && formik.errors.tenantId && (
                                                <FormHelperText error>{formik.errors.tenantId}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Stack>
                                </Grid>


                                {/* roles Dropdown */}
                                <Grid item xs={12} sm={6}>
                                    <Stack spacing={1}>
                                        <FormControl fullWidth
                                                     error={Boolean(formik.touched.roles && formik.errors.roles)}>
                                            <InputLabel htmlFor="element-roles">roles</InputLabel>
                                            <Select
                                                id="element-roles"
                                                {...formik.getFieldProps('roles')}
                                                value={formik.values.roles}
                                                onChange={(e) => formik.setFieldValue('roles', e.target.value)}
                                            >
                                                <MenuItem value="USER">User</MenuItem>
                                                <MenuItem value="ADMIN">Admin</MenuItem>
                                            </Select>
                                            {formik.touched.roles && formik.errors.roles && (
                                                <FormHelperText>{formik.errors.roles}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Stack>
                                </Grid>
                                {/* Active Checkbox */}
                                {/*<Grid item xs={6} >
                                   <Stack spacing={1}>
                                       <InputLabel htmlFor="element-enabled">
                                       <FormattedMessage id="Active" defaultMessage="Active" />
                                       </InputLabel>
                                       <FormControlLabel
                                           control={
                                               <Checkbox
                                                   id="element-enabled"
                                                   checked={formik.values.enabled}
                                                   onChange={(e) => formik.setFieldValue('enabled', e.target.checked)}
                                                   name="enabled"
                                                   color="primary"
                                               />
                                           }
                                           label={<FormattedMessage id="Enabled" defaultMessage="Enabled" />}
                                       />
                                       {formik.touched.enabled && formik.errors.enabled && (
                                           <span style={{ color: 'red' }}>{formik.errors.enabled}</span>
                                       )}
                                   </Stack>
                               </Grid>*/}
                            </Grid>
                        </DialogContent>
                        <Divider/>
                        <DialogActions sx={{p: 2.5}}>
                            <Grid container justifyContent="flex-end" alignItems="center">
                                <Grid item>
                                    <Stack direction="row" spacing={2} alignItems="center">
                                        <Button color="error" onClick={closeModal}>
                                            <FormattedMessage id="Cancel" defaultMessage="Cancel"/>
                                        </Button>
                                        <Button type="submit" variant="contained">
                                            <FormattedMessage id="Save" defaultMessage="Save"/>
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </Form>
                </FormikProvider>
            </>
        );
    }
}